import { combineSlices } from '@reduxjs/toolkit';
import { authenticateApi } from '../services/portal/authenticateApi';
import { portalApi } from '../services/portal/portalApi';

import authSlice from './slices/auth-slice';
import cacheTags from './slices/cache-tag-slice';
import { projectsApi } from './../services/projects/projectsApi';
import { connectApi } from '../services/connectApi';
import { dashboardsApi } from '../services/projects/dashboardsApi';
import { fleetAnalyticsApi } from '../services/fleetAnalytics/fleetAnalyticsApi';
import { userDetailsApi } from '../services/projects/userDetailsApi';

import clientsReducer from '../legacy/reducers/reducer-clients';
import updatesReducer from '../legacy/reducers/reducer-updates';
import activeClientReducer from '../legacy/reducers/reducer-active-client';
import activeProjectReducer from '../legacy/reducers/reducer-active-project';
import activeFacilityReducer from '../legacy/reducers/reducer-active-facility';
import activeContactReducer from '../legacy/reducers/reducer-active-contact';
import activeVehicleReducer from '../legacy/reducers/reducer-active-vehicle';
import activeScheduleReducer from '../legacy/reducers/reducer-active-schedule';
import activeLoggerAssignmentReducer from '../legacy/reducers/reducer-active-logger-assignment';
import activeScheduleGroupReducer from '../legacy/reducers/reducer-active-schedule-group';
import activeFleetReducer from '../legacy/reducers/reducer-active-fleet';
import addProjectReducer from '../legacy/reducers/reducer-add-project-flow';
import appStateReducer from '../legacy/reducers/reducer-app-state';
import powerLoggersReducer from '../legacy/reducers/reducer-power-loggers';
import measureWorkflowReducer from '../legacy/reducers/reducer-measure-workflow';
import operationsReducer from '../legacy/reducers/reducer-operations';
import batteriesReducer from '../legacy/reducers/reducer-batteries';
import chargersReducer from '../legacy/reducers/reducer-chargers';
import teamsReducer from '../legacy/reducers/reducer-teams';
import motivePowerReducer from '../legacy/reducers/reducer-motive_power';
import taskDataReducer from '../legacy/reducers/reducer-task-data';
import userReducer from '../legacy/reducers/reducer-users';
import modelWorkflowReducer from '../legacy/reducers/reducer-model-workflow';
import tasksReducer from '../legacy/reducers/reducer-tasks';
import fleetsReducer from '../legacy/reducers/reducer-fleets';
import alertConfigurationsReducer from '../legacy/reducers/reducer-alert-configurations';
import policyDocumentReducer from '../legacy/reducers/reducer-policy-document';
import assetsReducer from '../legacy/reducers/reducer-assets';
import deviceConfigsReducer from '../legacy/reducers/reducer-device-config';
import chargerConfigsReducer from '../legacy/reducers/reducer-charger-configs';
import versionMetasReducer from '../legacy/reducers/reducer-version-metas';
import activeResourceReducer from '../legacy/reducers/reducer-active-resource';
import activeAddressReducer from '../legacy/reducers/reducer-active-address';
import tagsReducer from '../legacy/reducers/reducer-tags';
import mostRecentReducer from '../legacy/reducers/reducer-logger-most-recent';
import gatewayConfigsReducer from '../legacy/reducers/reducer-gateway-configs';
import batteryConfigsReducer from '../legacy/reducers/reducer-battery-configs';
import newTeamsReducer from '../legacy/reducers/reducer-new-teams';
import viewsReducer from '../legacy/reducers/reducer-views';
import customerGroupsReducer from '../legacy/reducers/reducer-customer-groups';
import portalRoleDefinitionsReducer from '../legacy/reducers/reducer-portal-role-definitions';
import portalGroupDefinitionsReducer from '../legacy/reducers/reducer-portal-group-definitions';
import vanadiumBESSConfigsReducer from '../legacy/reducers/reducer-vanadium-bess-configs';
import leadAcidBESSConfigsReducer from '../legacy/reducers/reducer-leadacid-bess-configs';
import dimensionsReducer from '../legacy/reducers/reducer-dimensions';
import licenseReducer from '../legacy/reducers/reducer-licenses';
import { locationReportApi } from '../services/license/locationReportApi';
import { configApi } from '../services/configApi';
import { reducer as formReducer } from 'redux-form';
import pdfSlice from '../legacy/reducers/pdf-slice';
import { simulatorApi } from '../services/stream/streamApi';

const appReducer = combineSlices({
  auth: authSlice,
  cacheTags: cacheTags,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [portalApi.reducerPath]: portalApi.reducer,
  [authenticateApi.reducerPath]: authenticateApi.reducer,
  [connectApi.reducerPath]: connectApi.reducer,
  [dashboardsApi.reducerPath]: dashboardsApi.reducer,
  [fleetAnalyticsApi.reducerPath]: fleetAnalyticsApi.reducer,
  [userDetailsApi.reducerPath]: userDetailsApi.reducer,
  [locationReportApi.reducerPath]: locationReportApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [simulatorApi.reducerPath]: simulatorApi.reducer,
  // LEGACY
  activeAddress: activeAddressReducer,
  activeClient: activeClientReducer,
  activeContact: activeContactReducer,
  activeFacility: activeFacilityReducer,
  activeFleet: activeFleetReducer,
  activeLoggerAssignment: activeLoggerAssignmentReducer,
  activeProject: activeProjectReducer,
  activeResource: activeResourceReducer,
  activeSchedule: activeScheduleReducer,
  activeScheduleGroup: activeScheduleGroupReducer,
  activeVehicle: activeVehicleReducer,
  addProjectFlow: addProjectReducer,
  alertConfigurations: alertConfigurationsReducer,
  appState: appStateReducer,
  assets: assetsReducer,
  batteries: batteriesReducer,
  batteryConfigs: batteryConfigsReducer,
  chargerConfigs: chargerConfigsReducer,
  chargers: chargersReducer,
  clients: clientsReducer,
  customerGroups: customerGroupsReducer,
  deviceConfigs: deviceConfigsReducer,
  dimensions: dimensionsReducer,
  fleets: fleetsReducer,
  form: formReducer,
  gatewayConfigs: gatewayConfigsReducer,
  leadAcidBESSConfigs: leadAcidBESSConfigsReducer,
  licenses: licenseReducer,
  pdf: pdfSlice,
  loggersMostRecent: mostRecentReducer,
  measureWorkflow: measureWorkflowReducer,
  modelWorkflow: modelWorkflowReducer,
  motivePower: motivePowerReducer,
  newTeams: newTeamsReducer,
  operations: operationsReducer,
  policyDocument: policyDocumentReducer,
  portalGroupDefinitions: portalGroupDefinitionsReducer,
  portalRoleDefinitions: portalRoleDefinitionsReducer,
  powerLoggers: powerLoggersReducer,
  tags: tagsReducer,
  taskData: taskDataReducer,
  tasks: tasksReducer,
  teams: teamsReducer,
  updates: updatesReducer,
  users: userReducer,
  vanadiumBESSConfigs: vanadiumBESSConfigsReducer,
  versionMetas: versionMetasReducer,
  views: viewsReducer,
  //cacheTags,
});

const rootReducer = (state = {}, action: any) => {
  if (action.type === 'LOGOUT_USER') {
    if (import.meta.env?.VITE_APP_GOOGLE_ANALYTICS_TAG && (window as any)?.gtag) {
      window?.gtag('config', import.meta.env?.VITE_APP_GOOGLE_ANALYTICS_TAG, {
        user_id: undefined,
      });
    }
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
